import React from "react";
import { Box } from "@mui/system";
import { Container, Typography } from "@mui/material";
import { mainHeading, subHeading } from "../styles/style";
import Layout from "../assets/Layout";

export default function PrivacyPolicy() {
  return (
    <>
      <Layout>
        <Box sx={{ textAlign: "center", my: 10 }}>
          <Typography sx={subHeading}>Policies</Typography>
          <Typography sx={mainHeading}>Privacy Policies</Typography>
        </Box>

        <Container >
          <Box my={2}>
            <Typography  className="subHeading1Details">Overview</Typography>
            <Typography className="textDetails">
              PPLACD understands that your privacy is important and sets out
              policies to guarantee the protection of your privacy while using
              our website. This Privacy Policy sets out the procedures and
              policies of PPLACD (from now on referred to as "we," "our," or
              "us") regarding the collection, use, and disclosure of personal
              information we receive about the users or from them on the website
              of PPLACD.
            </Typography>
            <Typography className="textDetails">
              By using this site, you agree to be bound by the terms and
              conditions of this Privacy Policy. By accepting the Privacy Policy
              or accessing the website, you expressly consent to our collection,
              use, and disclosure of your personal information following this
              Privacy Policy. If you disagree, kindly do not access this
              website.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography  className="subHeading1Details">Collection of Information</Typography>
            <Typography className="textDetails">
              We are passionate about user experience and collect some personal
              information from our users to provide an excellent experience. The
              information, like the name, email, phone number, location, and
              more, is considered the personal information of the user. Any
              personal information stored in our data about our users will be
              filled in directly by them.
            </Typography>
            <Typography className="textDetails">
              Even if the user/browser is not submitting or filling in any
              personal information to our website, we will gather and store some
              information about your visit, such as IP address, type of browser
              and operating system used, location, date, and time you access our
              website, pages you visit, and if you linked to our website from
              another website, the address of that website. This information is
              only for modifying purposes and analytics to provide the user with
              a better user experience and does not identify you personally and
              cannot be linked back to you.
            </Typography>
            <Typography className="textDetails">
              If you create an account or transact or fill out the contact form
              on this website or send personal correspondence, such as emails or
              letters, or if other users or third parties send us correspondence
              about your activities or postings on this website, we collect
              personally identifiable information from you or about you. Such
              personally identifiable information may include your name,
              address, email address, telephone number, and debit/credit card
              details. We retain this as necessary to resolve disputes, provide
              customer support, and troubleshoot problems as permitted by law.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography  className="subHeading1Details">Use and sharing of Information</Typography>
            <Typography className="textDetails">
              We acknowledge that any personal information of the user consists
              of several critical details which shouldn't be shared further with
              anyone without their consent. Therefore, we have a strict sharing
              and data storing policy to respect privacy.
            </Typography>
            <Typography className="textDetails">
              By agreeing to our policies or using our website, you agree that
              any information we receive about you or from you may be used by
              us(for marketing, and we can send mail to you directly) or shared
              by us with our affiliates and other third parties to help process
              your request; to comply with any law; to help improve our website
              or the products or services we offer; for research; to better
              understand our customers' needs; to develop new offerings, and to
              alert you to new products and services of us in which you may be
              interested.
            </Typography>
            <Typography  className="textDetails">
              Some general information of one user might be visible to another
              member of PPLACD for service delivery only after the consent of
              the users. For instance, the name and email of an employer might
              be visible to the candidates accessing PPLACD.
            </Typography>
            <Typography  className="textDetails">
              We may also combine the information you provide us with the data
              about you that is available to us internally or from other sources
              to serve you better. The resume submitted by you while applying to
              any job via PPLACD will be open for that particular employing
              organization to which you have applied.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography  className="subHeading1Details">Cookies</Typography>
            <Typography className="textDetails">
              "Cookies" are small identifiers sent from a web server and stored
              on your computer's hard drive, which helps us to recognize you if
              you revisit our website. Our website uses cookies to track how you
              found our website. To protect your privacy, we do not use cookies
              to store or transmit personal Information about you on the
              Internet. You can accept or decline cookies. Most web browsers
              automatically accept cookies, but you can usually modify your
              browser setting to decline cookies if you prefer. If you refuse
              cookies, certain site features may not function correctly. We do
              not control the Use of cookies by third parties.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography  className="subHeading1Details">Children</Typography>
            <Typography className="textDetails">
              If you are considered a minor in your country, you represent that
              you have your parent or legal guardian's permission to use the
              service. Parents or legal guardians must provide their verified
              consent for collecting, using, or disclosing a child's Personal
              Information. If you are a parent or legal guardian of a minor in
              your country, by allowing your child to use the service, you are
              subject to the terms of this agreement and responsible for your
              child's activity on the service.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography  className="subHeading1Details">Governing law and jurisdiction</Typography>
            <Typography className="textDetails">
              The provisions of this Privacy Policy are governed by and
              construed following the laws of India. You agree to submit to the
              exclusive jurisdiction of the courts in Rajasthan, India.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">Severability</Typography>
            <Typography className="textDetails">
              The provisions covered in this Privacy Policy are enforceable and
              independent of each other. If any provision is determined by the
              competent court to be unenforceable, the other provisions will
              continue in effect.
            </Typography>
          </Box>
          <Box >
            <Typography  className="subHeading1Details">Changes to this privacy policy</Typography>
            <Typography className="textDetails">
              This Privacy Policy is effective as of March 2023 and will remain
              in effect except concerning any changes in its provisions in the
              future. The changes to the conditions of this Privacy Policy will
              come into effect immediately after being posted on this website.
              We may change our Privacy Policy from time to time. If we do, we
              will update this Privacy Policy on our website, which will bind to
              you as and when updated. Your continued use of the service after
              we post any modifications to the Privacy Policy on the Site will
              constitute your acknowledgement of the modifications and your
              consent to abide by and be bound by the modified Privacy Policy.
              Suppose we make any material changes to this Privacy Policy. In
              that case, we will notify you either through your email address or
              by placing a prominent notice on the website.
            </Typography>
          </Box>
          <Box >
            <Typography my={2} className="subHeading1Details">Grievance Officer</Typography>
            <Typography className="textDetails">
              Following the Information Technology Act, 2000 (as amended) and
              rules made thereunder, the name and contact details of the
              Grievance Officer who may be contacted are:
            </Typography>

            <Typography mt={1} className="subHeading2Mid">Grievance officer:<span style={{color:"#2544EE"}} > Ashish Gupta</span></Typography>
            <Typography mt={1} className="subHeading2Mid">Email id:<span style={{color:"#2544EE"}}> info@pplacd.com</span> </Typography>
            <Typography mt={1} className="subHeading2Mid">Mobile: <span style={{color:"#2544EE"}}>+91-98100-22488</span> </Typography>
          </Box>
        </Container>
      </Layout>
    </>
  );
}
